import ReCAPTCHA from "react-google-recaptcha";
import { appConfig } from "../../config";

const captchaKey = appConfig.captcha.key

export default function Recaptcha({
  setCaptcha,
  ref = null,
}: {
  setCaptcha(data: any): void;
  ref?: any;
}) {
  return (
    <>
      <ReCAPTCHA
        ref={ref}
        sitekey={captchaKey}
        onChange={(data) => setCaptcha(data)}
        onErrored={() => setCaptcha(null)}
        onExpired={() => setCaptcha(null)}
      />
    </>
  );
}
